export default __webpack_public_path__ + "static/media/GoldFrame05.b1aa3162.png";